import { partitionSubmissionDocuments } from "components/Submission/helpers/documentHelpers";
import { GetSubmissionQuery, ReviewerStatus } from "generated-graphql/graphql";
import { CurrentUser } from "providers/user";

type Submission = NonNullable<GetSubmissionQuery["submission"]>;

// Export this type so it can be used in reviewStates.ts
export type SubmissionDocumentReviewWithReviewer =
  Submission["reviewers"][number]["submissionDocumentReviews"][number];

/**
 * Retrieves the most recent submission document review for a specific user
 * Finds the reviewer by userId and returns their most recent review (sorted by createdAt)
 * Returns null if the reviewer is not found or has no reviews
 */
export function getReviewersSubmissionDocumentReview(
  submission?: Submission | null,
  userId?: string | null | undefined
): SubmissionDocumentReviewWithReviewer | null {
  if (!submission || !userId) {
    return null;
  }

  const reviewer = submission.reviewers.find(
    (reviewer) => reviewer.user.id === userId
  );
  if (!reviewer) {
    return null;
  }
  if (reviewer.submissionDocumentReviews.length === 0) {
    return null;
  }

  // Create a copy of the array before sorting (Apollo Client freezes cached arrays)
  const reviewersSubmissionDocumentReview = [
    ...reviewer.submissionDocumentReviews,
  ].sort((a, b) => {
    const dateA = new Date(a.createdAt).getTime();
    const dateB = new Date(b.createdAt).getTime();
    return dateB - dateA;
  });

  return reviewersSubmissionDocumentReview[0];
}
